import InnerWrapper from '../InnerWrapper'
import Modal from 'components/Modal'
import NoResults from 'components/NoResults'
import Spinner from 'components/Spinner'
import TSTable from 'components/Tanstack'

import { useOrders } from './use-orders'
import { useOrdersDetails } from './use-orders-details'
import { useTablesOrders } from './use-tables-orders'
import { useTablesOrdersDetails } from './use-tables-orders-details'
import { useTablesOrdersCards } from './use-tables-orders-cards'

const Index: React.FC = (): JSX.Element => {
  const {
    data: dataOrders,
    isLoading: isLoadingOrders,
    isError: isErrorOrders,
    isSuccess: isSuccessOrders,
  } = useOrders()

  const {
    selectedRowData: dataTableSelectedRow,
    selectedModal: dataTableSelectedModal,
    dataTable: dataTableOrders,
    columns: dataTableColumns,
    handleActionModalClose,
  } = useTablesOrders({ dataTable: dataOrders || [] })

  const {
    data: dataOrdersDetails,
    isLoading: isLoadingOrdersDetails,
    isError: isErrorOrdersDetails,
    isSuccess: isSuccessOrdersDetails,
  } = useOrdersDetails({ dataTableSelectedRow })

  const {
    dataTable: dataTableOrdersDetails,
    columns: dataTableColumnsOrdersDetails,
  } = useTablesOrdersDetails({
    dataTable: dataOrdersDetails ? dataOrdersDetails.orderDetails : [],
  })

  const {
    dataTable: dataTableOrdersCards,
    columns: dataTableColumnsOrdersCards,
  } = useTablesOrdersCards({
    dataTable: dataOrdersDetails ? dataOrdersDetails.cardDetails : [],
  })

  return (
    <>
      <InnerWrapper title="Orders">
        {/* FILTER */}
        {/* <OrdersFilterForm
        formStatus={memberOrdersModStatus}
        formDefaultValues={memberOrdersFilterParams}
        onFilter={memberHandleOrdersFilter}
        onFilterClear={memberHandleOrdersUnfilter}
      /> */}

        {/* ADVANCE SEARCH  */}
        {/* <div className="pb-6">
          <ToggleMenu
            type="search"
            label="Search Memos/Orders"
            isTriggeToggle={memberOrdersModStatus === 'success' || false}
          >
            <OrdersFilterForm
              formStatus={memberOrdersModStatus}
              formDefaultValues={memberOrdersFilterParams}
              onFilter={memberHandleOrdersFilter}
              onFilterClear={memberHandleOrdersUnfilter}
            />
          </ToggleMenu>
        </div> */}

        {/* FAIL */}
        {isErrorOrders ? (
          <NoResults
            header="Failed to load data"
            subtitle="Please refresh the page and try again, or contact
        your system administrator"
            noImage
          />
        ) : null}

        {/* LOADING */}
        {isLoadingOrders ? <Spinner /> : null}

        {/* SUCCESS */}
        {dataOrders && isSuccessOrders ? (
          <TSTable.Table data={dataTableOrders} columns={dataTableColumns} />
        ) : null}

        {/* EMPTY */}
        {!dataOrders && isSuccessOrders ? (
          <NoResults
            header="No available data"
            subtitle="There is no available data to display"
            noImage
          />
        ) : null}
      </InnerWrapper>

      {/* ORDER MODALS */}
      {dataTableSelectedModal === 'orders_details_preview' &&
      dataTableSelectedRow ? (
        <Modal
          open={true}
          title="Order Details"
          onClose={handleActionModalClose}
          noFooter
          modalSize="large"
        >
          {/* LOADING */}
          {isLoadingOrdersDetails ? <Spinner /> : null}
          {/* SUCCESS */}
          {dataOrdersDetails && isSuccessOrdersDetails ? (
            <TSTable.Table
              data={dataTableOrdersDetails}
              columns={dataTableColumnsOrdersDetails}
            />
          ) : null}
        </Modal>
      ) : null}

      {dataTableSelectedModal === 'orders_cards_preview' &&
      dataTableSelectedRow ? (
        <Modal
          open={true}
          title="Order Cards"
          onClose={handleActionModalClose}
          noFooter
          modalSize="large"
        >
          {/* LOADING */}
          {isLoadingOrdersDetails ? <Spinner /> : null}
          {/* SUCCESS */}
          {dataOrdersDetails && isSuccessOrdersDetails ? (
            <TSTable.Table
              data={dataTableOrdersCards}
              columns={dataTableColumnsOrdersCards}
            />
          ) : null}
        </Modal>
      ) : null}
    </>
  )
}

export default Index
